// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Page_Wrapper__xj-Hg","Title":"Page_Title__2fGs5","Content":"Page_Content__1LSxg","Controls":"Page_Controls__3GVky","ControlsEnd":"Page_ControlsEnd__3nEyq"};